export const contentTableConfig = {
  title: '直播间购买记录',
  propList: [
   {prop: 'customerName', label: '客户姓名', minWidth: '80'},
    {prop: 'nickname', label: '微信昵称', minWidth: '80'},
    {prop: 'unionid', label: '客户unionid', minWidth: '80'},
    {prop: 'channelName', label: '直播间名称', minWidth: '80',},
    {prop: 'productName', label: '商品名', minWidth: '80',},
    {prop: 'price', label: '支付金额', minWidth: '80',slotName: 'price'},
    {prop: 'signUrl', label: '合同链接', minWidth: '80',slotName: 'signUrl'},
    {prop: 'isSigned', label: '是否已签约', minWidth: '80'},
    {prop: 'deptName', label: '所属部门', minWidth: '80'},
    {prop: 'empName', label: '所属员工', minWidth: '80'},
    {prop: 'payTime', label: '购买时间', minWidth: '80'},
    {prop: 'orderId', label: '支付单号', minWidth: '80'},
    {prop: 'status', label: '支付状态', minWidth: '80',slotName: 'status'},
    {prop: 'channelCode', label: '支付渠道', minWidth: '80',slotName: 'channelCode'},
    {prop: 'isRefund', label: '是否退款', minWidth: '80'},
    {prop: 'refundAmount', label: '退款金额', minWidth: '80',slotName: 'refundAmount'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
